<div class="commentary-container" data-cy="draft-detail-commentary">
  <div class="commentary-content" [innerHTML]="consultCommentary?.commentary ? consultCommentary?.commentary : ''" data-cy="draft-detail-commentary-text"></div>
  <div class="footer">
    <div class="row">
      <div class="col-4 col-md-8 avatar-col">
        <div class="draft-consultant-avatar" data-cy="draft-detail-commentary-avatar">
          <img [src]="consultCommentary?.photo" alt="consultant photo"/>
        </div>
      </div>
      <div class="col-8 col-md-4 consultant-name-col">
        <span data-cy="draft-detail-commentary-collaborator-name">{{ consultCommentary?.consultant ? (consultCommentary?.consultant?.name + ' ' + consultCommentary?.consultant?.surname) : '' }}</span>
      </div>
    </div>
  </div>
</div>
